<template>
	<div class="sub-total">
		<div class="sub-total-details">
			<div class="sub-total-number">
				<h1>Subtotal:</h1>
				<template v-if="$route.name.includes('-accessories')">
					<promo-sales-timed>
						<template v-slot:originalContent>
							<span>{{ total | formatMoney }}</span>
						</template>
						<template>
							<span>
								{{ promoDiscount(total) | formatMoney }}
							</span>
						</template>
					</promo-sales-timed>
				</template>
				<template v-else>
					<promo-sales-timed>
						<template v-slot:originalContent>
							<span class="without-shipping">{{ total | formatMoney }}</span>
							<span class="with-shipping hide">{{ totalWithShipping | formatMoney }}</span>
						</template>
						<template>
							<span class="without-shipping">{{ promoDiscount(total) | formatMoney }}</span>
							<span class="with-shipping hide">{{ promoDiscount(totalWithShipping) | formatMoney }}</span>
						</template>
					</promo-sales-timed>
				</template>
				<span class="currency-code">USD</span>
			</div>
			<p>{{ landingPageSections1.body | stripTags }}</p>
			<!-- <promo-sales-timed>
				<template v-slot:originalContent>
					<p>{{ landingPageSections1.body | stripTags }}</p>
				</template>
				<template slot-scope="{ phasesInfo: { currentPhase } }">
					<promo-savings-msg
						v-if="currentPhase == 1"
						:phase="currentPhase"
						text="accessories_cart"
						:price="total"
						:shipping="landingPageSections1.body | stripTags"
					/>
					<promo-savings-msg
						v-if="currentPhase == 2"
						:phase="currentPhase"
						text="accessories_cart_old"
						:price="total"
						:shipping="landingPageSections1.body | stripTags"
					/>
				</template>
			</promo-sales-timed> -->
		</div>
		<div class="sub-total-action">
			<button
				v-if="!isOutOfStock"
				type="button"
				class="btn continue-to-cart text-uppercase"
				:class="buttonClass"
				@click="action"
			>
				<slot />
			</button>
			<button
				v-else
				type="button"
				class="btn continue-to-cart btn-soldout"
				:class="buttonClass"
			>
				SOLD OUT
			</button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PromoSalesTimed from "@/components/promo-sales-timed";
// import PromoSavingsMsg from "@c/generals/promo-savings-msg";
import { promoDiscount } from "@u/helpers";

export default {
	name: "Subtotal",
	components: {
		// PromoSavingsMsg,
		PromoSalesTimed
	},
	props: {
		action: {
			type: Function,
			required: true
		},
		buttonClass: {
			type: [String, Object],
			default: ""
		}
	},
	computed: {
		...mapGetters({
			userShipping: "userShipping",
			totalMonitors: "StarterPc/totalMonitors"
		}),
		...mapState({
			cartCase: state => state.StarterPc.cart.case,
			landingPageSections1: state => state.StarterPc.pageData.landing_page_sections[1],
			stockVariants: state => state.StarterPc.builds[state.StarterPc.buildsIndex].variants,
			total: state => state.StarterPc.total
		}),
		isOutOfStock() {
			const build = this.stockVariants.find(variant => variant.case_id == this.cartCase.id);

			return build && build.stock == 0;
		},
		totalWithShipping() {
			return this.total +
				Number.parseFloat(this.userShipping.amount) +
				Number.parseFloat(this.userShipping.amount_extra.monitor) * this.totalMonitors;
		}
	},
	methods: {
		promoDiscount
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.sub-total {
	max-width: 575px;
	display: flex;

	@media (min-width: 1200px) {
		align-items: center;
	}

	.disable-element {
		opacity: 0.5;
	}

	@media (max-width: 991px) {
		flex-direction: column;
	}

	@media (min-width: 320px) and (max-width: 580px) {
		width: 100%;
		margin-left: 0;
		margin-right: 0;
		align-items: flex-start;
	}

	&-details {
		display: flex;
		flex-direction: column;

		@media (max-width: 991px) {
			margin-left: 60px;
			margin-right: 40px;
		}

		@media (min-width: 320px) and (max-width: 580px) {
			margin: 22px 0;
			margin-left: 0;
			margin-right: 0;
		}

		.sub-total-number {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.currency-code {
				align-self: flex-end;
				font-size: 14px;
				font-weight: 200;
				margin-bottom: -4px;
				margin-left: 2px;

				@media (min-width: 320px) and (max-width: 580px) {
					margin-bottom: -2px;
				}

				@media only screen
				and (min-device-width : 768px)
				and (max-device-width : 1024px)
				and (orientation : portrait) {
					align-self: auto;
				}

			}

			@media (max-width: 991px) {
				justify-content: flex-start;
			}

			h1 {
				color: #5f707f;
				margin-top: 0;
				margin-bottom: 0;
				font-size: 32px;
				line-height: 38px;

				@media (max-width: 991px) {
					font-size: 20px;
					line-height: 24px;
				}
			}

			span {
				color: #51007a;
				font-size: 32px;
				line-height: 38px;
				margin-left: 8px;

				@media (max-width: 991px) {
					font-size: 20px;
					line-height: 24px;
					margin-left: 5px;
				}
			}
		}

		p {
			color: #5f707f;
			font-size: 16px;
			line-height: 19px;
			margin-bottom: 0;
			text-align: right;

			@media (max-width: 991px) {
				font-size: 14px;
				line-height: 18px;
			}

			@media (max-width: 580px) {
				text-align: left;
			}
		}
	}

	.continue-to-cart {
		background: $purple;
		border-color: $purple;
		color: $white;
		margin-left: 20px;

		&:hover {
			background: transparent;
			color: $purple;
		}

		@media (max-width: 991px) {
			margin-left: 0;
			width: 100%;
		}
	}

	&-action {
		display: flex;
		width: auto;
		@media (min-width: 320px) and (max-width: 580px) {
			width: 100%;
		}

		.btn-soldout {
			background-color: rgba(#5F707F, 0.3);
			border: none;
			color: $white;
			pointer-events: none;
		}
	}
}

.sub-total::v-deep {
	.promo-savings-msg {
		margin-bottom: 0;
		text-align: right;

		p {
			display: block;
			width: 320px;
			font-size: 14px;
			line-height: 19px !important;
			color: #5f707f !important;
		}
	}

	@media (min-width: 320px) and (max-width: 480px) {
		.promo-savings-msg {
			text-align: left;
		}
	}
}

</style>
